module.exports = __webpack_public_path__ + "static/Pathways-15bb70edcd388aa554c92e85cf39f34e.png";